import { render, staticRenderFns } from "./DragAndDropIcon.vue?vue&type=template&id=10061b12&"
import script from "./DragAndDropIcon.vue?vue&type=script&lang=js&"
export * from "./DragAndDropIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports